"use strict";

exports.__esModule = true;
var _CreateTicketTypeScreen = require("./CreateTicketTypeScreen");
Object.keys(_CreateTicketTypeScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CreateTicketTypeScreen[key]) return;
  exports[key] = _CreateTicketTypeScreen[key];
});